import React, { useEffect, useMemo, useState } from "react";
import { CustomDialog, TitledTextField } from "..";
import { translate } from "../../providers";
import { roundTo } from "../../utils";
import styles from "./ConsumptionTrackingSidePanel.module.css";

const prepareDate = (date) => date.split("T")[0];
const formatDate = (date) => {
	const y = date.getFullYear();
	const m = String(date.getMonth() + 1).padStart(2, "0");
	const d = String(date.getDate()).padStart(2, "0");
	return `${y}-${m}-${d}`;
};

const QuotaExtentionDialog = ({ consumption, onClose, onExtendQuota, open }) => {
	const [renewalDate, setRenewalDate] = useState(null);
	const [newLimit, setNewLimit] = useState(0);
	const now = useMemo(() => new Date(), []);
	const today = useMemo(() => new Date(now.getFullYear(), now.getMonth(), now.getDate()), [now]);
	const maxDate = useMemo(() => {
		const date = new Date();
		date.setDate(today.getDate() + 90);
		return date;
	}, [today]);
	const dateTooEarly = useMemo(() => new Date(renewalDate) < today, [renewalDate, today]);
	const dateTooLate = useMemo(() => new Date(renewalDate) > maxDate, [renewalDate, maxDate]);
	const disableSubmit = useMemo(
		() => Number.isNaN(newLimit) || newLimit < 0 || dateTooEarly || dateTooLate,
		[newLimit, dateTooEarly, dateTooLate]
	);

	useEffect(() => {
		if (open) {
			if (consumption?.windowsEnd) {
				setRenewalDate(prepareDate(consumption?.windowsEnd));
			}
			if (consumption.totalLimit) {
				setNewLimit(consumption.totalLimit / 1000000);
			}
		}
	}, [open, consumption]);
	const handleClose = () => {
		setRenewalDate(prepareDate(consumption?.windowsEnd));
		setNewLimit(0);
		onClose();
	};
	const handleSubmit = () => {
		onExtendQuota(consumption.quotaId, consumption.type, newLimit * 1000000, `${prepareDate(renewalDate)} 23:59`);
		handleClose();
	};
	const handleChangeLimit = (value) => {
		setNewLimit(parseInt(value, 10));
	};
	const handleChangeDate = (value) => {
		setRenewalDate(value);
	};
	return (
		<CustomDialog
			open={open}
			submitDisabled={disableSubmit}
			title={translate(`common:company.quotas.extention.dialog.${consumption?.type?.toLowerCase()}.title`)}
			onClose={handleClose}
			onSubmit={handleSubmit}
		>
			<TitledTextField
				required
				adornment="M"
				min={0}
				placeholder="0"
				title={translate("common:company.quotas.extention.dialog.additional-tokens.title")}
				tooltip={translate("common:company.quotas.extention.dialog.additional-tokens.tooltip")}
				type="number"
				value={roundTo(newLimit, 2)}
				onChange={handleChangeLimit}
			/>
			{newLimit < 0 && <span className={styles.error}>{translate("common:company.quotas.error.number")}</span>}
			<TitledTextField
				required
				max={formatDate(maxDate)}
				min={formatDate(today)}
				title={translate("common:company.quotas.extention.dialog.date.title")}
				tooltip={translate("common:company.quotas.extention.dialog.date.tooltip")}
				type="date"
				value={renewalDate}
				onChange={handleChangeDate}
			/>
			{dateTooEarly && <span className={styles.error}>{translate("common:company.quotas.error.min-date")}</span>}
			{dateTooLate && <span className={styles.error}>{translate("common:company.quotas.error.max-date")}</span>}
		</CustomDialog>
	);
};

export default QuotaExtentionDialog;
